import { Injectable } from '@angular/core';
import { AppToolBarComponent, ToolbarDisposition } from '../app-tool-bar/app-tool-bar.component';
import { Observable } from 'rxjs';
import { VisibilityElementToolbar } from 'src/app/classes/json-interface';
import { CST_LOCALSTORAGE_VALUE } from 'src/app/classes/const';
import { g_params } from 'src/app/classes/global-param';
import { CUtilit } from 'src/app/classes/utilit';



@Injectable({
  providedIn: 'root'
})
export class AppToolbarService {

  // TODO service a refaire
  // Il faudrais que le service ne contienne que des setter & getter entre la toolbar & les autre page
  // Il faudrais stocker tout ce qui est parametre du composant toolbar dans ce service pour pouvoir etre modfiable depuis n'importe ou avec des setter
  // Les getter pour recuperer les données sur le composant toolbar

  private mToolbarComponent?: AppToolBarComponent;

  constructor() {}

  public setToolbarComponent(toolbarComponent: AppToolBarComponent) {
    this.mToolbarComponent = toolbarComponent;
    if (!toolbarComponent) {
      console.warn('Toolbar undefined !');
    }
  }

  /**
   * Change la visibilité des informations dans la toolbars
   * en fonction des differentes pages
   * @param disposition ?
   */
  public setDisposition(disposition: ToolbarDisposition) {
    this.setVisibility(true);
    this.mToolbarComponent?.updateDispotition(disposition);
  }

  public getObservableClick(clear: boolean): Observable<string> {
    if (!this.mToolbarComponent)
      return new Observable<string>();
    return this.mToolbarComponent.getObservableBtnClick(clear);
  }

  public getObservableSiteChange(): Observable<string> {
    if (!this.mToolbarComponent)
      return new Observable<string>();
    return this.mToolbarComponent.getObservableSiteChange();
  }

  public setVisibility(visibility: boolean) {
    if (!this.mToolbarComponent)
      return;
    this.mToolbarComponent.HTML_VisibilityToolbar = visibility;
  }

  public refreshToolbar(cleanSiteCode: boolean = false) {
    this.mToolbarComponent?.refresh(cleanSiteCode);
  }

  public getToolbarHeight(): number {
    const element = <HTMLElement> document.getElementById('id-main-toolbar');
    return element ? element.clientHeight : 68;
  }

  public set toolbarPageTitle(val: string) {
    if (!this.mToolbarComponent)
      return;
    this.mToolbarComponent.HTML_PageTitle = val;
    document.title = 'ArmaWeb ' + val;
  }

  /**
   * Il s'agit du code chantier
   * Sauvegarde en parametre le code chantier de la toolbar
   * Nessecaire si on recharge la page & que l'on doit reafecter le code chantier selectionner de la toolbar
   */
  get selectedSiteCode(): string {
    return CUtilit.getSelectedSiteCode();
  }

  public setSelectedSiteCode(siteCode: string) {
    if (!siteCode) return;
    for (let i = 0 ; i < g_params.g_arraySite.length ; i++) {
      if (g_params.g_arraySite[i].CODECHANTIER == siteCode) {
        sessionStorage.setItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode, siteCode);
        break;
      }
    }
  }

  set toolbarLock(lock: boolean) {
    if (!this.mToolbarComponent)
      return;
    this.mToolbarComponent.setLockToolbatButton(lock);
  }

  /**
   * Ne fait que update les boolean qui sont inscrit dans la fonction
   */
  public updateToolbarElementVisibility(elementVisibility: VisibilityElementToolbar) {
    if (!this.mToolbarComponent)
      return;
    if (elementVisibility)
      this.mToolbarComponent.setVisibilityElementToolbar(elementVisibility);
  }

  public resetToolBarElementVisibility() {
    if (!this.mToolbarComponent)
      return;
    this.mToolbarComponent.initVisibilityElementToolbar();
  }
}
